import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { playbackId: String, lessonId: Number }

  connect() {
    // TODO: Initialize @mux/mux-player when package is added
  }
}
